import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { APP_CONFIG, AUTH_METHOD, AUTH_TOKEN, COMPANY_ID, IAppConfig } from '@recruitee/common';
import { HttpApiErrorHandlerService, HttpApiService } from '@recruitee/http';

import { TellentAdminRequestData } from './../lib/tellent-admin-request-data';

@Injectable({ providedIn: 'root' })
export class TellentHttpApiService extends HttpApiService {
  constructor() {
    super(
      inject(HttpClient),
      inject(TellentAdminRequestData),
      inject(HttpApiErrorHandlerService),
      inject(AUTH_TOKEN),
      inject(COMPANY_ID),
      inject(AUTH_METHOD),
      <IAppConfig>inject(APP_CONFIG),
    );
  }
}
